function initServicesToggle() {
    var mainCont = $('.x-branches .region-area-two');
    $(".x-branches .js-toggle").click(function () {
        var hiddenCont = $(this).siblings('.js-content-accord');
        $(this).toggleClass('icon-down-4 icon-up-4');
        if (hiddenCont.hasClass('opened')) {
            hiddenCont.removeClass('opened');
        } else {
            mainCont.find('.opened').removeClass('opened').siblings('.js-toggle').toggleClass('icon-down-4 icon-up-4');
            hiddenCont.addClass('opened');
        } 
    });

    var accordion = false; 

    if ($(window).width() <= 767) {
        accordion = true;
    }

    $(window).resize(function () {
        if ($(window).width() > 767) {
            if (accordion) {
                $('.js-content-accord', mainCont).removeClass('opened');
                accordion = false;
            }
        }
        else {
            if (!accordion) {
                $('.js-content-accord', mainCont).siblings('.js-toggle').addClass('icon-down-4').removeClass('icon-up-4');
                accordion = true;
            }
        }
    });

    function setCurrentDay() {
        var $wrapper = $('.x-branches');

        var  d = new Date();
        var dayNumber = d.getDay();
        if(dayNumber == 0) dayNumber = 7;
        
        $('.service-details-list > li',$wrapper).each(function(){
            $('.today-hours .today-date-hours', $(this)).html($('.week-day[data-daynumber=' + dayNumber +']', $(this)).html());
            $('.week-day[data-daynumber=' + dayNumber +']', $(this)).addClass('current');
        });
    }

    setCurrentDay();
}

initServicesToggle();